import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-codebook-list',
	templateUrl: './codebook-list.component.html',
	styleUrls: ['./codebook-list.component.css'],
})
export class CodebookListComponent extends ListComponent {
	protected apiUrl = 'codebook';
	protected apiType = 'bag';
	tableRows = [{ id: 'name', name: 'Nazwa' }];

	protected convertData(data: any) {
		return data.results.map((item) => {
			item.id = item.url;
			return item;
		});
	}
}
